import * as React from 'react';
import { useState } from 'react';

// @ts-ignore
import closeIcon from '../../images/close.svg';

const JobAlerts: React.FC = () => {
	const [popupOpened, setPopupOpened] = useState(false);
	return (
		<section className={'bg-bt-blue px-3'} id="job_alerts">
			<div className={'container mx-auto py-6 text-center text-white  '}>
				<h2 className={'font-rubik text-[32px] font-normal mb-2'}>
					Sign up for Job Alerts
				</h2>
				<p className={'font-rubik text-lg'}>
					Join our talent community to stay up to date with Belle Tire
					as a potential employer
				</p>
				<button
					className={
						'mt-0 w-44 rounded-full bg-white p-3 px-14 font-open-sans text-xl font-bold text-bt-blue hover:bg-bt-red hover:text-white'
					}
					onClick={() => {
						setPopupOpened(true);
					}}
				>
					JOIN
				</button>
			</div>
			<div
				className={[
					'fixed top-0 bottom-0 right-0 left-0 bg-[rgba(0,0,0,0.40)]',
					!popupOpened ? 'hidden' : ''
				].join(' ')}
			>
				<div
					className={
						'flex h-full w-full flex-row items-center justify-center'
					}
				>
					<div
						className={'container flex items-center justify-center'}
					>
						<div
							className={
								'rounded bg-white px-12 shadow max-sm:px-5'
							}
						>
							<div className={'flex flex-row justify-between'}>
								<span
									className={
										' py-8 font-rubik text-2xl font-bold text-bt-blue'
									}
								>
									JOIN THE TALENT COMMUNITY
								</span>
								<button
									onClick={() => {
										setPopupOpened(false);
									}}
								>
									<img
										width={26}
										className={'hover:opacity-70'}
										src={closeIcon}
										alt={'close popup window'}
									/>
								</button>
							</div>
							<iframe
								className={
									'max-sm:h-[45 0px] h-[400px] max-h-full w-[500px]	max-w-full'
								}
								style={{ border: 'none', maxHeight: '100%' }}
								src={
									'https://recruiting.adp.com/srctcb/public/portlet.guid?t=1026007&z=COLLECTOR&tt=VC_CAREERS_WEBSITE'
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default JobAlerts;
